import { SessionInferenceMode } from "@/components/graphql/schema.graphql";

import { InferenceForm as InferenceFormPayloadType } from "../../types";

export type FilterTabType = "all" | "favorite";
export type ObjectTabType = "all" | "file" | "asset";

export const FILTERS = {
  SEARCH: "search",
  TAB: "tab",
} as const;

export const DEFAULT_FILTERS_VALUES = {
  [FILTERS.SEARCH]: "",
  [FILTERS.TAB]: "all",
} as const;

export const DEFAULT_INFERENCE_FORM: InferenceFormPayloadType = {
  defaults: {
    initImageWeight: 0.5,
    controlnetImageWeight: 1,
  },
  parameters: {
    batchSize: 4,
    width: 1024,
    height: 1024,
    prompt: "",
    seed: -1,
    numInferenceSteps: 20,
    guidanceScale: 4,
  },
};

export const FORGE_ERROR_DURATION_MS = 4000;
export const NUM_INITIAL_OBJECTS = 8;
export const DEFAULT_FORGE_SESSION_NAME = "Untitled Session";
export const NEW_SESSION_ID = "new";
export const NEW_ASSET_ID = "new";
export const MODES_SUPPORTING_PROMPT_SUGGESTIONS: SessionInferenceMode[] = [
  "CREATE",
  "CREATE_VIDEO",
  "CREATE_3_D",
  "REALTIME",
];

export const MODES_SUPPORTING_FORGE_EXPLORER: SessionInferenceMode[] = [
  "CREATE",
  "CREATE_VIDEO",
  "CREATE_3_D",
];

export const MODES_WITH_SOURCE_IMAGES: SessionInferenceMode[] = [
  "PROMPT_EDIT_IMAGE",
  "UPSCALE",
  "REMOVE_BACKGROUND",
  "VECTORIZE_IMAGE",
  "REFRAME_IMAGE",
];

export const MODES_WITH_SOURCE_VIDEOS: SessionInferenceMode[] = [
  "PROMPT_EDIT_VIDEO",
  "UPSCALE_VIDEO",
  "REFRAME_VIDEO",
  "REMOVE_BACKGROUND_VIDEO",
  "ADD_SFX_VIDEO",
];

export const MODES_WITH_SOURCE_MESHES: SessionInferenceMode[] = [
  "RETEXTURE_MESH",
  "REMESH",
  "RIG_MESH",
];
